import { FeatureFlagTypes } from './featureFlagsTypes.enum';

export const RouteToSunsetFlag: Record<string, FeatureFlagTypes> = {
  'ai-in-line-control': FeatureFlagTypes.ReactHideInlineControlPage,
};

export const RouteToFeatureFlagType: { [route: string]: FeatureFlagTypes } = {
  ai: FeatureFlagTypes.EnterpriseAiDashboard,
  'ai-detection': FeatureFlagTypes.EnterpriseAiDetection,
  'ai-findings': FeatureFlagTypes.EnterpriseAiDetection,
  'ai-activity': FeatureFlagTypes.EnterpriseAiDetection,
  'ai-prevention': FeatureFlagTypes.AIRuntimePreventionMockTab,
  'ai-data-insights': FeatureFlagTypes.AIRuntimeDataInsightsTab,
  'ai-in-line-control': FeatureFlagTypes.InlinePrevention,
  policies: FeatureFlagTypes.BlockPolicyPage,
  connect: FeatureFlagTypes.EnableAdaptersLayout,
  integrations: FeatureFlagTypes.BlockLegacyIntegrations,
  'attack-simulations': FeatureFlagTypes.RedTeaming,
  boundaries: FeatureFlagTypes.RsaDemoRuntimeBoundaries,
};
